import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  setBusinessManagerService: ['data'],
});

export const BusinessManager = Types;
export default Creators;
